import React from "react";
import { Box } from "@chakra-ui/react";

export function MetricIcon() {
  return (
    <Box as="svg" xmlns="http://www.w3.org/2000/svg" boxSize="icon.xl" viewBox="0 0 32 32" fill="none">
      <Box
        as="path"
        fill="new.blue.900"
        d="M26.6667 25.3332C27.403 25.3332 28 25.9302 28 26.6666C27.9999 27.4029 27.403 27.9999 26.6667 27.9999H5.33333C4.59702 27.9999 4.00011 27.4029 4 26.6666C4 25.9302 4.59695 25.3332 5.33333 25.3332H26.6667Z"
      />
      <Box
        as="path"
        fill="new.blue.900"
        d="M23.0573 8.39052C23.578 7.86983 24.422 7.86983 24.9427 8.39052C25.4634 8.91123 25.4634 9.75526 24.9427 10.2759L20 15.2186C19.5 15.7187 18.8217 15.9998 18.1146 15.9999H13.8854L8.94271 20.9426C8.42202 21.4632 7.57798 21.4632 7.05729 20.9426C6.53661 20.4219 6.53664 19.5779 7.05729 19.0572L12 14.1145C12.5 13.6144 13.1782 13.3333 13.8854 13.3332H18.1146L23.0573 8.39052Z"
      />
    </Box>
  );
}
